import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Box from '@mui/material/Box';
import type { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const GeneralDataInfo = ({ sx }: { sx?: SxProps }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-test="info-text-container"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 0.5,
        ...sx,
      }}
    >
      <InfoRoundedIcon data-test="info-icon" sx={{ color: theme => theme.palette.text.secondary }} />
      <Typography
        variant="body2"
        data-test="info-text"
        sx={{
          color: 'text.secondary',
        }}
      >
        {t(
          'The green and red arrows indicate the percentage change between your selected period and the period prior.'
        )}
      </Typography>
    </Box>
  );
};
